import { useEffect, useState } from 'react';
import {
  getConsultations,
  updateConsultation,
  isMissingTable,
} from '../services/adminApi';
import DataTable from '../components/DataTable';
import MissingTable from '../components/MissingTable';

const STATUSES = ['pending', 'scheduled', 'completed', 'cancelled'];

const fmtDate = (d) =>
  d
    ? new Date(d).toLocaleString('en-IN', {
        day: 'numeric',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '—';

export default function Consultations() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = async () => {
    const { data, error } = await getConsultations();
    setRows(data);
    setError(error);
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  if (error && isMissingTable(error))
    return <MissingTable table="consultations" />;

  const setField = async (row, field, value) => {
    setRows((prev) =>
      prev.map((r) => (r.id === row.id ? { ...r, [field]: value } : r))
    );
    const { error } = await updateConsultation(row.id, { [field]: value });
    if (error) {
      alert(`Update failed: ${error.message}`);
      load();
    }
  };

  return (
    <div>
      <div className="page-head">
        <h1>Consultations</h1>
      </div>

      {error && !isMissingTable(error) && (
        <p className="admin-error">Failed to load: {error.message}</p>
      )}

      <DataTable
        loading={loading}
        emptyMessage="No consultation requests yet."
        columns={[
          {
            key: 'customer_name',
            label: 'Customer',
            render: (c) => (
              <div>
                <div className="cell-title">{c.customer_name || '—'}</div>
                <div className="cell-sub">{c.customer_phone || ''}</div>
              </div>
            ),
          },
          {
            key: 'birth_date',
            label: 'Birth Details',
            render: (c) => (
              <div>
                <div>{c.birth_date || '—'}</div>
                <div className="cell-sub">
                  {[c.birth_time, c.birth_place].filter(Boolean).join(' · ')}
                </div>
              </div>
            ),
          },
          {
            key: 'astrologer_name',
            label: 'Astrologer',
            render: (c) => (
              <input
                className="inline-input"
                defaultValue={c.astrologer_name || ''}
                placeholder="Assign astrologer"
                onBlur={(e) => {
                  if (e.target.value !== (c.astrologer_name || ''))
                    setField(c, 'astrologer_name', e.target.value);
                }}
              />
            ),
          },
          {
            key: 'scheduled_at',
            label: 'Scheduled',
            render: (c) => fmtDate(c.scheduled_at),
          },
          {
            key: 'status',
            label: 'Status',
            render: (c) => (
              <select
                className="status-select"
                value={c.status || 'pending'}
                onChange={(e) => setField(c, 'status', e.target.value)}
              >
                {STATUSES.map((s) => (
                  <option key={s}>{s}</option>
                ))}
              </select>
            ),
          },
          {
            key: 'notes',
            label: 'Notes',
            render: (c) => (
              <input
                className="inline-input"
                defaultValue={c.notes || ''}
                placeholder="Add note"
                onBlur={(e) => {
                  if (e.target.value !== (c.notes || ''))
                    setField(c, 'notes', e.target.value);
                }}
              />
            ),
          },
        ]}
        rows={rows}
      />
    </div>
  );
}
